export default __webpack_public_path__ + "static/media/srt2.955006e6.png";